"use client";
// Imports
import Link from "next/link";
import { Card as ShadCard } from "../../ui/card";
import {
  AddToMyShowButton,
  ViewDetails,
  Img,
  EventTimes,
  Placeholder,
} from "@/components";
import {
  getFirstImage,
  getShowAddToMyShow,
  getDatesEventIsOn,
  getEventTimesByDay,
} from "@/lib/helpers";
// Row Card
export function RowCard({
  userId,
  price,
  url,
  data,
  collectionHandle,
  showDates,
  selectedDay,
  mapIsActive,
  index = 0,
}) {
  // Variables
  const { title } = data;
  const image = getFirstImage(collectionHandle, data);
  const showAddToMyShow = getShowAddToMyShow(collectionHandle);

  let eventTimes;

  if (collectionHandle == "events") {
    const dates = getDatesEventIsOn(data, showDates);
    eventTimes = getEventTimesByDay(dates, selectedDay);
  }

  return (
    <div
      className="flex flex-col w-full animate-card-in"
      style={{ "--anim-delay": `${Math.min(index, 15) * 25}ms` }}
    >
        <ShadCard
          className={`flex h-full border-2 ${
            collectionHandle === "events" ? "bg-white" : ""
          }`}
        >
          <div className="flex flex-col gap-2 p-2 space-y-3 lg:flex-row lg:gap-6 lg:space-y-0 lg:p-6">
            <div>
              <div className="overflow-hidden relative w-full h-64 lg:size-64 rounded-base">
                {image?.permalink ? (
                  <Img
                    className="h-full rounded-l-md"
                    sizes="(max-width: 1024px) 100vw, 400px"
                    fill
                    data={image}
                  />
                ) : (
                  <Placeholder
                    className="aspect-square w-full h-full"
                    type="image-placeholder"
                  />
                )}
                <div className="block absolute top-2 right-2 lg:hidden">
                  <AddToMyShowButton
                    userId={userId}
                    type={collectionHandle}
                    slug={data.slug}
                    image={image}
                    title={title}
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-between w-full lg:flex-row">
              <div className="space-y-2">
                <h2 className="level-3">{title}</h2>
                <p>{data?.short_description}</p>
                <EventTimes
                  eventTimes={eventTimes}
                  everyDay={data?.every_day}
                  collectionHandle={collectionHandle}
                  hideTimesOnCard={data?.hide_times_on_card}
                />

                {price && <p>${price}</p>}
              </div>
              <div className="flex flex-col justify-between items-end pt-4 h-full lg:pt-0">
                <div className="hidden lg:block">
                  <AddToMyShowButton
                    userId={userId}
                    type={collectionHandle}
                    slug={data.slug}
                    image={image}
                    title={title}
                  />
                </div>

                <ViewDetails
                  mapIsActive={mapIsActive}
                  collectionHandle={collectionHandle}
                  data={data}
                  image={image}
                  showAddToMyShow={showAddToMyShow}
                  eventTimes={eventTimes}
                />
              </div>
            </div>
          </div>
        </ShadCard>
    </div>
  );
}
